// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msg {
  width: 100%;
  display: inline-flex;
}

.profile_pic {
  display: block;
  margin-right: 10px;
  min-width: 40px;
  pointer-events: all;
}
.profile_pic img {
  min-height: 40px;
  min-width: 40px;
  max-height: 40px;
  max-width: 40px;
  object-fit: cover;
  border-radius: 50%;
  background: #f5e2d3;
  border: 1px solid #f5e2d3;
}

.message_content {
  display: block;
  height: -moz-fit-content;
  height: fit-content;
}

.msg_box {
  width: -moz-fit-content;
  width: fit-content;
  padding: 8px 12px;
  box-sizing: border-box;
  font-weight: 900;
  font-size: 0.9375rem;
  margin: 6px 0;
  display: block;
  transition: all 1s ease;
  pointer-events: all;
  border-radius: 21px;
  word-wrap: break-word;
  max-width: 75vw;
}
.msg_box a {
  color: #fff;
  text-decoration: underline;
}

.img_msg_box {
  width: -moz-fit-content;
  width: fit-content;
  box-sizing: border-box;
  font-weight: 900;
  display: block;
  width: fit-content;
  max-height: 35vh;
  transition: all 1s ease;
  border-radius: 21px;
  width: 250px;
  max-height: 400px;
}
.img_msg_box img {
  object-fit: cover;
  object-position: center;
  border-radius: 21px;
  width: 100%;
  height: 100%;
  min-height: 150px;
  background: #fafafa;
  background-image: url('loader.webp');
  background-size: cover;
  background-position: center;
}
.img_msg_box a {
  color: #fff;
  text-decoration: underline;
}

.img_stamp {
  margin: 0px -10px;
}

.time_stamp {
  font-size: 10px;
  color: rgba(149, 149, 149, 0.9098039216);
  margin-bottom: 2px;
  margin-top: 2px;
  display: inline-block;
  width: 100%;
  height: 20px;
}

.left_message .msg_box,
.left_message .img_msg_box {
  background: #dedede;
  color: #6b6b6b;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 21px;
}
.left_message .msg_box img,
.left_message .img_msg_box img {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 21px;
}

.right_message .message_content {
  float: right;
  width: 100%;
}
.right_message .msg_box,
.right_message .img_msg_box {
  background: #b08d7b;
  color: #fff;
  margin: 0 0;
  float: right;
  line-height: 20px;
  max-width: 326px;
  border-bottom-left-radius: 21px;
  border-bottom-right-radius: 6px;
}
.right_message .msg_box img,
.right_message .img_msg_box img {
  border-bottom-left-radius: 21px;
  border-bottom-right-radius: 6px;
}
.right_message .time_stamp {
  text-align: right;
}

.rejected_box label {
  text-decoration: line-through;
}

.buttons {
  margin-top: 10px;
  display: inline-flex;
  width: 100%;
}
.buttons button {
  margin-left: 5px;
  margin-right: 5px;
  border: none;
  padding: 12px;
  font-size: 11px;
  text-transform: uppercase;
  background: #a95858;
  color: #fff;
  border-radius: 3px;
  font-weight: 900;
  width: 100%;
}
.buttons .full {
  width: 100%;
}
.buttons .green {
  background: #72b472;
  background: #bba497;
}

.lilcurr {
  font-size: 10px;
  text-align: center;
  width: 100%;
}

.offer_box {
  box-shadow: 0px 0px 10px #303030;
  text-align: center !important;
}
.offer_box .offer_label {
  background: #fff3e6;
  color: #bba497;
  padding: 6px;
  font-size: 35px;
  min-width: 250px;
  text-align: left;
  display: block;
  text-align: center;
  font-family: monospace;
  border-radius: 9px;
  box-shadow: 0px 0px 10px #aeaeae;
}

.reveal_box {
  padding: 27px !important;
  background: rgba(9, 32, 70, 0.3215686275) !important;
  border: 2px solid rgba(9, 32, 70, 0.3294117647) !important;
}

.free-scroll {
  pointer-events: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/messenger/msg-message/msg-message.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,oBAAA;AACJ;;AAGA;EACI,cAAA;EACA,kBAAA;EAEA,eAAA;EAEA,mBAAA;AAFJ;AAII;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAHR;;AAOA;EACI,cAAA;EACA,wBAAA;EAAA,mBAAA;AAJJ;;AAOA;EACI,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,aAAA;EAEA,cAAA;EACA,uBAAA;EAEA,mBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,eAAA;AARJ;AAUI;EACI,WAAA;EACA,0BAAA;AARR;;AAYA;EACI,uBAAA;EAAA,kBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,iBAAA;AAXJ;AAaI;EACI,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,2BAAA;AAZR;AAeI;EACI,WAAA;EACA,0BAAA;AAbR;;AAiBA;EACI,iBAAA;AAdJ;;AAiBA;EACI,eAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAdJ;;AAkBI;;EAEI,mBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;AAfR;AAiBQ;;EACI,8BAAA;EACA,gCAAA;AAdZ;;AAoBI;EACI,YAAA;EACA,WAAA;AAjBR;AAwBI;;EAEI,mBAAA;EACA,WAAA;EAEA,WAAA;EAEA,YAAA;EACA,iBAAA;EAEA,gBAAA;EAGA,+BAAA;EACA,+BAAA;AA3BR;AA6BQ;;EACI,+BAAA;EACA,+BAAA;AA1BZ;AA6BI;EACI,iBAAA;AA3BR;;AAgCI;EACI,6BAAA;AA7BR;;AAiCA;EACI,gBAAA;EACA,oBAAA;EACA,WAAA;AA9BJ;AAgCI;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AA9BR;AAiCI;EACI,WAAA;AA/BR;AAkCI;EACI,mBAAA;EACA,mBAAA;AAhCR;;AAoCA;EACI,eAAA;EACA,kBAAA;EACA,WAAA;AAjCJ;;AAoCA;EACI,gCAAA;EACA,6BAAA;AAjCJ;AAmCI;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;AAjCR;;AAqCA;EACI,wBAAA;EACA,oDAAA;EACA,0DAAA;AAlCJ;;AAqCA;EACI,+BAAA;AAlCJ","sourcesContent":[".msg {\n    width: 100%;\n    display: inline-flex;\n    //pointer-events: none;\n}\n\n.profile_pic {\n    display: block;\n    margin-right: 10px;\n\n    min-width: 40px;\n\n    pointer-events: all;\n\n    img {\n        min-height: 40px;\n        min-width: 40px;\n        max-height: 40px;\n        max-width: 40px;\n\n        object-fit: cover;\n        border-radius: 50%;\n        background: #f5e2d3;\n        border: 1px solid #f5e2d3;\n    }\n}\n\n.message_content {\n    display: block;\n    height: fit-content;\n}\n\n.msg_box {\n    width: fit-content;\n    padding: 8px 12px;\n    box-sizing: border-box;\n    font-weight: 900;\n    font-size: 0.9375rem;\n\n    margin: 6px 0;\n\n    display: block;\n    transition: all 1s ease;\n\n    pointer-events: all;\n    border-radius: 21px;\n\n    word-wrap: break-word;\n    max-width: 75vw;\n\n    a {\n        color: #fff;\n        text-decoration: underline;\n    }\n}\n\n.img_msg_box {\n    width: fit-content;\n    box-sizing: border-box;\n    font-weight: 900;\n\n    display: block;\n    width: fit-content;\n    max-height: 35vh;\n    transition: all 1s ease;\n    border-radius: 21px;\n\n    width: 250px;\n    max-height: 400px;\n\n    img {\n        object-fit: cover;\n        object-position: center;\n        border-radius: 21px;\n        width: 100%;\n        height: 100%;\n        min-height: 150px;\n\n        background: #fafafa;\n        background-image: url(\"../../../assets/loader.webp\");\n        background-size: cover;\n        background-position: center;\n    }\n\n    a {\n        color: #fff;\n        text-decoration: underline;\n    }\n}\n\n.img_stamp {\n    margin: 0px -10px;\n}\n\n.time_stamp {\n    font-size: 10px;\n    color: rgba(149, 149, 149, 0.9098039216);\n    margin-bottom: 2px;\n    margin-top: 2px;\n    display: inline-block;\n    width: 100%;\n    height: 20px;\n}\n\n.left_message {\n    .msg_box,\n    .img_msg_box {\n        background: #dedede;\n        color: #6b6b6b;\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 21px;\n\n        img {\n            border-bottom-left-radius: 8px;\n            border-bottom-right-radius: 21px;\n        }\n    }\n}\n\n.right_message {\n    .message_content {\n        float: right;\n        width: 100%;\n    }\n\n    // .inner_msg_box {\n    //     min-height: 45px;\n    // }\n\n    .msg_box,\n    .img_msg_box {\n        background: #b08d7b;\n        color: #fff;\n\n        margin: 0 0;\n\n        float: right;\n        line-height: 20px;\n\n        max-width: 326px;\n\n        //text-align: right;\n        border-bottom-left-radius: 21px;\n        border-bottom-right-radius: 6px;\n\n        img {\n            border-bottom-left-radius: 21px;\n            border-bottom-right-radius: 6px;\n        }\n    }\n    .time_stamp {\n        text-align: right;\n    }\n}\n\n.rejected_box {\n    label {\n        text-decoration: line-through;\n    }\n}\n\n.buttons {\n    margin-top: 10px;\n    display: inline-flex;\n    width: 100%;\n\n    button {\n        margin-left: 5px;\n        margin-right: 5px;\n        border: none;\n        padding: 12px;\n        font-size: 11px;\n        text-transform: uppercase;\n        background: #a95858;\n        color: #fff;\n        border-radius: 3px;\n        font-weight: 900;\n        width: 100%;\n    }\n\n    .full {\n        width: 100%;\n    }\n\n    .green {\n        background: #72b472;\n        background: #bba497;\n    }\n}\n\n.lilcurr {\n    font-size: 10px;\n    text-align: center;\n    width: 100%;\n}\n\n.offer_box {\n    box-shadow: 0px 0px 10px #303030;\n    text-align: center !important;\n\n    .offer_label {\n        background: #fff3e6;\n        color: #bba497;\n        padding: 6px;\n        font-size: 35px;\n        min-width: 250px;\n        text-align: left;\n        display: block;\n        text-align: center;\n        font-family: monospace;\n        border-radius: 9px;\n        box-shadow: 0px 0px 10px #aeaeae;\n    }\n}\n\n.reveal_box {\n    padding: 27px !important;\n    background: #09204652 !important;\n    border: 2px solid #09204654 !important;\n}\n\n.free-scroll {\n    pointer-events: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
